import { render, staticRenderFns } from "./Countdown.vue?vue&type=template&id=604d8b3a"
import script from "./Countdown.vue?vue&type=script&lang=js"
export * from "./Countdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('604d8b3a')) {
      api.createRecord('604d8b3a', component.options)
    } else {
      api.reload('604d8b3a', component.options)
    }
    module.hot.accept("./Countdown.vue?vue&type=template&id=604d8b3a", function () {
      api.rerender('604d8b3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/takover-warning/Countdown.vue"
export default component.exports